var I18n, Optimize, config;

window._ = require('underscore');

window.md5 = require('../../../src/frontend/vendor/md5');

window.Cookie = require('../../../src/frontend/vendor/cookie');

window.Hogan = require('hogan.js');

require('../groupon_modules/modernizr-hacks');

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('optimize-suite');

require('../../../src/frontend/vendor/eventPause-custom');

require('jquery.finger');

window.CartWidget = require('../../../modules/cart_widget/frontend/cart_widget');

window.Fingerprint = require('fingerprintjs');

Optimize = window.Optimize;

config = Optimize.suiteData.config;

config.finch = {
  config: Optimize.finchConfig
};

Optimize.config = config;

OptimizeSuite.init(config);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvY29tbW9uL2NvcmVfbGlicmFyaWVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2NvbW1vbi9jb3JlX2xpYnJhcmllcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFNLENBQUMsQ0FBUCxHQUFXLE9BQUEsQ0FBUSxZQUFSOztBQUNYLE1BQU0sQ0FBQyxHQUFQLEdBQWtCLE9BQUEsQ0FBUSxrQ0FBUjs7QUFDbEIsTUFBTSxDQUFDLE1BQVAsR0FBa0IsT0FBQSxDQUFRLHFDQUFSOztBQUNsQixNQUFNLENBQUMsS0FBUCxHQUFlLE9BQUEsQ0FBUSxVQUFSOztBQUNmLE9BQUEsQ0FBUSxvQ0FBUjs7QUFDQSxJQUFBLEdBQU8sT0FBQSxDQUFRLDJDQUFSOztBQUNQLE1BQU0sQ0FBQyxJQUFQLEdBQWtCLElBQUEsSUFBQSxDQUFBOztBQUNsQixPQUFBLENBQVEsZ0JBQVI7O0FBRUEsT0FBQSxDQUFRLGdEQUFSOztBQUNBLE9BQUEsQ0FBUSxlQUFSOztBQUNBLE1BQU0sQ0FBQyxVQUFQLEdBQW9CLE9BQUEsQ0FBUSxtREFBUjs7QUFDcEIsTUFBTSxDQUFDLFdBQVAsR0FBcUIsT0FBQSxDQUFRLGVBQVI7O0FBRXBCLFdBQVk7O0FBQ1osU0FBVSxRQUFRLENBQUM7O0FBQ3BCLE1BQU0sQ0FBQyxLQUFQLEdBQWU7RUFBQSxNQUFBLEVBQVEsUUFBUSxDQUFDLFdBQWpCOzs7QUFDZixRQUFRLENBQUMsTUFBVCxHQUFrQjs7QUFDbEIsYUFBYSxDQUFDLElBQWQsQ0FBbUIsTUFBbkIifQ==
